import React from 'react';

/**
 * Globe icon for currency breakdown in chart tooltip.
 * Uses inline SVG to work with renderToString().
 */
export const CurrencyIcon: React.FC = () => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" stroke="#6b7280" strokeWidth="1">
    <circle cx="5.5" cy="5.5" r="4.5" />
    <path d="M1 5.5h9M5.5 1c1.5 1.5 2 3 2 4.5s-.5 3-2 4.5c-1.5-1.5-2-3-2-4.5s.5-3 2-4.5" />
  </svg>
);

/**
 * Building icon for company breakdown in chart tooltip.
 * Uses inline SVG to work with renderToString().
 */
export const CompanyIcon: React.FC = () => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" stroke="#6b7280" strokeWidth="1">
    <rect x="2" y="1" width="7" height="9" rx="0.5" />
    <line x1="4" y1="3" x2="4" y2="3.5" />
    <line x1="7" y1="3" x2="7" y2="3.5" />
    <line x1="4" y1="5.5" x2="4" y2="6" />
    <line x1="7" y1="5.5" x2="7" y2="6" />
    <rect x="4.5" y="8" width="2" height="2" />
  </svg>
);
